<div class="panel"
     [style.width.px]="width"
     [style.height.px]="height"
     [ngClass]="{'has-action-buttons': hasActionButtons}"
     [@toggleTooltip]="{ value: animationState, params: { height: height } }"
     (@toggleTooltip.done)="onToggleTooltip($event)"
     (clickOutside)="onClickOutside()">
    <div class="buttons">
        <aa-popup-buttons></aa-popup-buttons>
    </div>
    <div class="since-calendar">
        <aa-popup-calendar [isSinceCalendar]="true">
        </aa-popup-calendar>
    </div>
    <div class="until-calendar">
        <aa-popup-calendar [isSinceCalendar]="false">
        </aa-popup-calendar>
    </div>
    <div class="footer" *ngIf="hasActionButtons">
        <div class="left-part">
            <aa-btn-action-secondary [size]="'small'"
                                     [btnText]="'BUTTON.RANGE.APPLY' | translate"
                                     [cta]="onApply">
            </aa-btn-action-secondary>
            &nbsp;&nbsp;
            <aa-btn-action-transparent [size]="'small'"
                                       [btnText]="'BUTTON.CANCEL' | translate"
                                       [cta]="onCancel">
            </aa-btn-action-transparent>
        </div>
        <div class="right-part">
            <aa-btn-action-transparent [size]="'small'"
                                       [btnText]="'BUTTON.RANGE.RESET' | translate"
                                       [cta]="onReset">
            </aa-btn-action-transparent>
        </div>
    </div>
</div>
